export default (function (_ref) {
  var request = _ref.request;
  return {
    videoAdd: function videoAdd(data) {
      return request({
        url: '/iot/video/add',
        method: 'post',
        data: data
      });
    },
    videoModify: function videoModify(data) {
      return request({
        url: "/iot/video/".concat(data.id, "/modify"),
        method: 'put',
        data: data
      });
    },
    videoDel: function videoDel(id) {
      return request({
        url: "/iot/video/".concat(id, "/del"),
        method: 'delete'
      });
    },
    videoQuery: function videoQuery(data) {
      return request({
        url: '/iot/video/query',
        method: 'get',
        params: data
      });
    },
    videoDetail: function videoDetail(id) {
      return request({
        url: "/iot/video/".concat(id, "/detail"),
        method: 'get'
      });
    },
    videoPlayUrl: function videoPlayUrl(id) {
      return request({
        url: "/iot/video/".concat(id, "/playUrl"),
        method: 'get'
      });
    }
  };
});